import defaultVariables from './defaultVariables.json';
import { BuilderFeatures } from '../BuilderFeatures';
import { STATE_ID_ONBOARDING } from './BuilderStateService';
export class VariablesService {
    constructor() {
        this.userVariables = [];
        this.variablesSet = new Map();
        this.taxDocumentObject = {
            value: 'contact.taxDocument',
            translate: 'variables.contact.taxDocument',
        };
        this.init();
    }
    async init() {
        await this.checkFeatures();
        this.defaultVariables = await this.getDefaultVariables();
    }
    async getDefaultVariables() {
        if (this.showTaxDocumentVariable) {
            defaultVariables.default.push(this.taxDocumentObject);
        }
        return defaultVariables.default;
    }
    setVariables(flow, configuration) {
        try {
            this.setUserVariables(flow, configuration);
            this.reduceUserVariablesByCompareNames();
        }
        catch (e) {
            console.error(e);
        }
    }
    setVariablesSecretConfiguration(flow, configuration, secretConfiguration) {
        try {
            this.setUserVariables(flow, configuration);
            this.userVariables = [
                ...this.userVariables,
                ...this.secretConfigurationVariables(secretConfiguration),
            ];
            this.reduceUserVariablesByCompareNames();
        }
        catch (e) {
            console.error(e);
        }
    }
    compareNames(a, b) {
        try {
            const nameA = a.toLowerCase();
            const nameB = b.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        }
        catch (err) {
            console.error(err);
            return 0;
        }
    }
    configurationVariables(configuration) {
        if (!configuration || Object.keys(configuration).length < 3) {
            return [];
        }
        return Object.keys(configuration).reduce((vars, key) => {
            if (key !== 'builder:minimumIntentScore' &&
                key !== 'builder:stateTrack') {
                return [...vars, key];
            }
            else {
                return vars;
            }
        }, []);
    }
    secretConfigurationVariables(secretConfiguration) {
        if (!secretConfiguration) {
            return [];
        }
        return Object.keys(secretConfiguration).reduce((vars, key) => {
            return [...vars, key];
        }, []);
    }
    customActionVariables(customActions, stateId = null) {
        let actionVars;
        return customActions.reduce((arr, action) => {
            switch (action.type) {
                case 'ProcessHttp':
                    actionVars =
                        action.settings &&
                            action.settings.responseStatusVariable
                            ? [action.settings.responseStatusVariable]
                            : [];
                    actionVars =
                        action.settings && action.settings.responseBodyVariable
                            ? [
                                ...actionVars,
                                action.settings.responseBodyVariable,
                            ]
                            : actionVars;
                    return [...arr, ...actionVars];
                case 'ExecuteScript':
                case 'ExecuteScriptV2':
                case 'ExecuteBlipFunction':
                case 'ExecuteTemplate':
                    actionVars =
                        action.settings && action.settings.outputVariable
                            ? [action.settings.outputVariable]
                            : [];
                    return [...arr, ...actionVars];
                case 'SetVariable':
                    // Para o bloco de onboarding, não incluir variáveis do SetVariable
                    // pois elas devem aparecer como output apenas
                    if (stateId === STATE_ID_ONBOARDING) {
                        return arr;
                    }
                    actionVars =
                        action.settings && action.settings.variable
                            ? [action.settings.variable]
                            : [];
                    return [...arr, ...actionVars];
                case 'SendCommand':
                    actionVars =
                        action.settings &&
                            action.settings.responseStatusVariable
                            ? [action.settings.responseStatusVariable]
                            : [];
                    actionVars =
                        action.settings && action.settings.responseBodyVariable
                            ? [
                                ...actionVars,
                                action.settings.responseBodyVariable,
                            ]
                            : actionVars;
                    return [...arr, ...actionVars];
                default:
                    return arr;
            }
        }, []);
    }
    contentActionsVariables(contentActions) {
        const re = RegExp('{{(.*?)}}', 'g');
        return contentActions.reduce((actions, curr) => {
            if (curr.input && curr.input.variable) {
                return [...actions, curr.input.variable];
            }
            else {
                return actions;
            }
        }, []);
    }
    // Método específico para coletar variáveis do SetVariable no OnBoarding como output
    onboardingSetVariableOutputs(customActions, stateId) {
        if (stateId !== STATE_ID_ONBOARDING) {
            return [];
        }
        return customActions.reduce((arr, action) => {
            if (action.type === 'SetVariable' && action.settings && action.settings.variable) {
                return [...arr, action.settings.variable];
            }
            return arr;
        }, []);
    }
    usedVariables(contentActions) {
        const re = RegExp('{{(.*?)}}', 'g');
        return contentActions.reduce((actions, curr) => {
            if (curr.action && curr.action.settings.type === 'text/plain') {
                const content = curr.action.settings.content;
                let contentVars = [], currVariables;
                while ((currVariables = re.exec(content)) !== null) {
                    contentVars = [...contentVars, currVariables[1]];
                }
                return [...actions, ...contentVars];
            }
            else {
                return actions;
            }
        }, []);
    }
    async checkFeatures() {
        this.showTaxDocumentVariable = await BuilderFeatures.isContactTaxDocumentEnabled();
    }
    setUserVariables(flow, configuration) {
        try {
            const variables = Object.keys(flow).reduce((array, key) => {
                const stateId = key;
                const contentActions = flow[key].$contentActions;
                const customActions = [...flow[key].$enteringCustomActions, ...flow[key].$leavingCustomActions];
                const vars = [
                    ...this.customActionVariables(customActions, stateId),
                    ...this.contentActionsVariables(contentActions),
                    // Para onboarding, adicionar variáveis do SetVariable como output
                    ...this.onboardingSetVariableOutputs(customActions, stateId),
                ];
                return [...array, ...vars];
            }, []);
            this.userVariables = [
                ...variables,
                ...this.configurationVariables(configuration),
            ];
        }
        catch (e) {
            console.error(e);
        }
    }
    reduceUserVariablesByCompareNames() {
        try {
            this.userVariables = this.userVariables
                .sort(this.compareNames)
                .reduce((arr, curr, i) => curr === this.userVariables[i + 1]
                ? arr
                : [...arr, curr], []);
        }
        catch (e) {
            console.error(e);
        }
    }
}
